import { ModuleService } from './module.service';
import { Body, Controller, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { ModuleResponse } from '@schemax-whatsapp/shared-models';
import { ModuleModel } from './models/module.model';
import { ModuleIdRequest } from './models/module-id.request';
import { CompanyIdRequest } from '../company/models/company-id.request';
import { ApiTags } from '@nestjs/swagger';

@ApiTags('module')
@Controller('module')
export class ModuleController {
    constructor(
        private moduleService: ModuleService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ) {

    }

    @Post('/createModule')
    async createModule(@Body() moduleReq: ModuleModel): Promise<ModuleResponse> {
        try {
            return await this.moduleService.createModule(moduleReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ModuleResponse, error);
        }
    }

    @Post('/editModule')
    async editModule(@Body() moduleReq: ModuleModel): Promise<ModuleResponse> {
        try {
            return await this.moduleService.editModule(moduleReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ModuleResponse, error);
        }
    }

    @Post('/deleteModule')
    async deleteModule(@Body() moduleIdReq: ModuleIdRequest): Promise<ModuleResponse> {
        try {
            return await this.moduleService.deleteModule(moduleIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ModuleResponse, error);
        }
    }

    @Post('/getAllModules')
    async getAllModules(): Promise<ModuleResponse> {
        try {
            return await this.moduleService.getAllModules();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ModuleResponse, error);
        }
    }
}
